import { Terms } from '@percent/workplace-giving/context/auth/authContext/AuthContext.types'
import { useAuth } from '@percent/workplace-giving/common/hooks'
import {
  getAcceptedTermsFromAuthState,
  getAccountConfigFromAuthState,
  getAccountFromAuthState
} from '@percent/workplace-giving/context/auth/authContextController/AuthContextController'

const EXPECTED_TERMS_2024: Terms[] = ['workplace:terms:2024-01-01', 'percent:privacy:2024-01-01']
const EXPECTED_TERMS_2025: Terms[] = ['workplace:terms:2025-12-15', 'percent:privacy:2025-12-15']

export const useShouldRunOnboarding = (): boolean => {
  const { state } = useAuth()
  const user = getAccountFromAuthState(state)
  const terms = getAcceptedTermsFromAuthState(state)
  const accountConfig = getAccountConfigFromAuthState(state)

  const hasCompleteNameInfo = !!user?.fullName && !!user?.preferredName
  const hasAcceptedTerms =
    EXPECTED_TERMS_2024.every(term => terms?.includes(term) ?? false) ||
    EXPECTED_TERMS_2025.every(term => terms?.includes(term) ?? false)
  const needsCurrency = !accountConfig?.currency

  return !hasCompleteNameInfo || !hasAcceptedTerms || needsCurrency
}
